/**
 * Logger plugin for raven
 * @function ravenLoggerPlugin
 */
module.exports = function ravenLoggerPlugin (Raven, console, debug) {
  var LOG_LEV_DEBUG = 0
  var LOG_LEV_INFO = LOG_LEV_DEBUG + 1
  var LOG_LEV_WARN = LOG_LEV_INFO + 1
  var LOG_LEV_ERROR = LOG_LEV_WARN + 1

  var LOG_METHODS = ['log', 'info', 'warn', 'error']
  var RAVEN_LOG_LEVEL = ['info', 'warning', 'error']
  var timer = {}

  function Logger (name) {
    this.moduleName = name
    this.enableDebug = debug
  }

  Logger.prototype.log = function (log_level, args) {
    var args = Array.prototype.slice.call(args)
    var logInfo = args.shift()
    var log = (this.enableDebug ? this.debugLog : this.productionLog).bind(this)
    var argsJSON = this.reparseJSON(args)

    log(log_level, logInfo, argsJSON)
  }

  Logger.prototype.debugLog = function (log_level, logInfo, argsJSON) {
    if (typeof console !== 'undefined' && typeof console[LOG_METHODS[log_level]] !== 'undefined') {
      try {
        console[LOG_METHODS[log_level]]('[' + this.moduleName + '] ', logInfo, argsJSON.length ? argsJSON : '')
      } catch (e) {
        console.error(e)
      }
    }
  }

  Logger.prototype.productionLog = function (log_level, logInfo, argsJSON) {
    if (log_level > LOG_LEV_DEBUG) {
      Raven[log_level === LOG_LEV_INFO ? 'captureMessage' : 'captureException'](logInfo, {
        level: RAVEN_LOG_LEVEL[log_level - 1],
        tags: {
          module: this.moduleName
        },
        fingerprint: [
          log_level,
          logInfo instanceof Error
            ? logInfo.message
            : logInfo,
          logInfo instanceof Error
            ? logInfo.stack
            : '',
        ],
        extra: {
          args: argsJSON
        }
      })
    }
  }

  Logger.prototype.reparseJSON = function (obj) {
    var result = {}
    try {
      result = JSON.parse(JSON.stringify(obj, this.replaceErrors))
    } catch (e) {}
    return result
  }

  Logger.prototype.replaceErrors = function (key, value) {
    if (value instanceof Error) {
      var error = {}

      Object.getOwnPropertyNames(value).forEach(function (key) {
        error[key] = value[key]
      })

      return error
    }

    return value
  }

  Raven.Logger = function (name) {
    var logger = new Logger(name)

    logger.debug = function () {
      logger.log(LOG_LEV_DEBUG, arguments)
    }

    logger.info = function () {
      logger.log(LOG_LEV_INFO, arguments)
    }

    logger.warn = function () {
      logger.log(LOG_LEV_WARN, arguments)
    }

    logger.error = function () {
      logger.log(LOG_LEV_ERROR, arguments)
    }

    logger.time = function (label) {
      timer['[' + logger.moduleName + '] ' + label] = new Date().valueOf()
    }

    logger.timeEnd = function (label) {
      var key = '[' + logger.moduleName + '] ' + label
      var lastTime = timer[key]

      if (!lastTime) return

      var time = new Date().valueOf() - lastTime

      logger.log(LOG_LEV_DEBUG, [label, { time: time + 'ms' }])
      timer['[' + logger.moduleName + '] ' + label] = null
    }

    return logger
  }

  if (typeof window !== 'undefined' && 'addEventListener' in window) {
    // 处理未被处理的promise异常
    var logger = Raven.Logger('Unhandled promise rejection')

    window.addEventListener('unhandledrejection', function (event) {
      logger.warn(event.reason)
    })
  }
}



//////////////////
// WEBPACK FOOTER
// ./~/@xunlei/raven-logger-plugin/index.js
// module id = 15
// module chunks = 1 2 3 5 6 7 8 9 10 11 12